module.exports = "../static/media/SweetWatch.9839aec9.svg";